import {FiEdit2, FiTool} from "react-icons/fi";
import {Link, useLocation} from "react-router";

import Button from "@/components/button/Button.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {Icon} from "@/components/icon/Icon.tsx";
import {GQL_CHECK_DETAILS} from "@/lib/queries/checks.ts";
import {Service} from "@/lib/types/checks.ts";
import {isFreeTrialExpired} from "@/lib/userUtils.ts";
import {CheckMoreActions} from "@/pages/checks/analysis/actions/CheckMoreActions.tsx";
import {CheckPauseResumeAction} from "@/pages/checks/analysis/actions/CheckPauseResumeAction.tsx";
import {baseSections, QUERY} from "@/pages/checks/constants.ts";

interface CheckAnalysisActionsBarProps {
  service: Service;
}

export const CheckAnalysisActionsBar = ({service}: CheckAnalysisActionsBarProps) => {
  const {user} = useCurrentUserContext();
  const location = useLocation();

  if (!user?.has_write_access || isFreeTrialExpired(user)) {
    return null;
  }

  return (
    <div className="d-flex flex-wrap align-items-center gap-2 px-4 py-3 border-bottom text-nowrap">
      <Button
        variant="primary"
        size="extraSmall"
        as={Link}
        to={`/checks/${service.id}/edit`}
        state={{from: location, refetchQueries: [GQL_CHECK_DETAILS]}}
      >
        <Icon icon={FiEdit2} />
        <span>Edit</span>
      </Button>

      <CheckPauseResumeAction id={service.id} isPaused={service.is_paused} isUp={service.cached_state_is_up} />

      <Button
        variant="secondary"
        size="extraSmall"
        as={Link}
        to={`/checks/${service.id}/edit?${QUERY.TAB}=${baseSections.maintenance_v2.id}`}
        state={{from: location, refetchQueries: [GQL_CHECK_DETAILS]}}
      >
        <Icon icon={FiTool} />
        <span>Maintenance</span>
      </Button>

      <CheckMoreActions service={service} />
    </div>
  );
};
